import { VideoStore } from '../../../../../common/js/stores/video.store';
import { ConfigStore } from '../../../../../common/js/stores/config.store';

export interface VideoStyles {
  container: Record<string, string | number>;
  videoContainer: Record<string, string | number>;
  videoWrapper: Record<string, string | number>;
  video: Record<string, string | number>;
  vpaidContainer: Record<string, string | number>;
}

export class VideoStyleStrategy {
  videoStore: VideoStore;
  configStore: ConfigStore;

  constructor(videoStore: VideoStore, configStore: ConfigStore) {
    this.videoStore = videoStore;
    this.configStore = configStore;
  }

  getStyles(): VideoStyles {
    return {
      container: this.getContainerStyle(),
      videoContainer: this.getVideoContainerStyle(),
      videoWrapper: this.getVideoWrapperStyle(),
      video: this.getVideoStyle(),
      vpaidContainer: this.getVpaidContainerStyle()
    };
  }

  /** @protected */
  protected getContainerStyle(): Record<string, string | number> {
    return {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background:
        this.videoStore.shouldRenderTransparentVideo() ||
        this.videoStore.shouldDisplayBlur.value
          ? 'transparent'
          : this.configStore.config.video?.containerBackgroundColor || '#000',
      opacity: this.configStore.config.isCreativeTransparent ? 0 : 1
    };
  }

  /** @protected */
  protected getVideoContainerStyle(): Record<string, string | number> {
    return {
      width: '100%',
      height: '100%'
    };
  }

  /** @protected */
  protected getVideoWrapperStyle(): Record<string, string | number> {
    return {
      width: '100%',
      height: this.videoStore.shouldDisplaySkin()
        ? this.videoStore.windowSize.value.width * (9 / 16) + 'px'
        : '100%',
      opacity: this.videoStore.shouldRenderTransparentVideo() ? 0 : 1,
      // fix for iOS 15 header ad : video appeared couple of ms after the container. adding background fix the issue
      background: this.videoStore.shouldAddVideoBackground.value
        ? 'rgba(0,0,0,.01)'
        : 'transparent',
      position: 'relative'
    };
  }

  /** @protected */
  protected getVideoStyle(): Record<string, string | number> {
    return {
      height: '100%',
      width: '100%'
    };
  }

  /** @protected */
  protected getVpaidContainerStyle(): Record<string, string | number> {
    return {
      height: '100%',
      width: '100%',
      position: 'absolute'
    };
  }
}
